<!-- ╔═════════════════════════ SIDE MENU ═════════════════════════╗ -->
<ion-menu
  id="mainMenu"
  contentId="main-content"
  type="overlay"
  side="start"
  class="custom-menu"
  swipeGesture="false"
>
  <ion-header>
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-menu-toggle>
          <ion-button fill="clear" color="light">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-menu-toggle>
      </ion-buttons>
      <ion-title class="text-center">
        {{ 'menu.title' | translate }}
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content class="menu-content">
    <ion-list lines="none" class="menu-list">
      <ion-menu-toggle auto-hide="true">
        <ion-item routerLink="/" routerDirection="root" detail="false">
          <ion-icon name="home-outline" slot="start"></ion-icon>
          <ion-label>{{ 'menu.home' | translate }}</ion-label>
        </ion-item>
      </ion-menu-toggle>

      <ion-menu-toggle auto-hide="true">
        <ion-item routerLink="/input" routerDirection="forward" detail="false">
          <ion-icon name="heart-circle-outline" slot="start"></ion-icon>
          <ion-label>{{ 'menu.input' | translate }}</ion-label>
        </ion-item>
      </ion-menu-toggle>

      <ion-menu-toggle auto-hide="true">
        <ion-item routerLink="/care" routerDirection="forward" detail="false">
          <ion-icon name="medkit-outline" slot="start"></ion-icon>
          <ion-label>{{ 'menu.care' | translate }}</ion-label>
        </ion-item>
      </ion-menu-toggle>

      <ion-menu-toggle auto-hide="true">
        <ion-item routerLink="/contact" routerDirection="forward" detail="false">
          <ion-icon name="call-outline" slot="start"></ion-icon>
          <ion-label>{{ 'menu.contact' | translate }}</ion-label>
        </ion-item>
      </ion-menu-toggle>
    </ion-list>
  </ion-content>
</ion-menu>

<!-- ║══════════════════ ROUTER OUTLET ══════════════════║ -->
<ion-router-outlet id="main-content"></ion-router-outlet>

<!-- ╚═════════ GLOBAL LANGUAGE SWITCHER (TOP-RIGHT) ═════════╝ -->
<!-- 🌐  Global language FAB  -->
<ion-fab
  #langFab
  slot="fixed"
  horizontal="end"
  vertical="top"
  class="lang-fab"
  style="--offset-x:-14px; --offset-y:56px"   
>
  <!-- main button -->
  <ion-fab-button
    size="large"
    aria-label="Change language"
    (click)="$any(langFab).toggleList()"
  >
    <ion-icon name="globe-outline"></ion-icon>
  </ion-fab-button>

  <!-- flag buttons -->
  <ion-fab-list side="bottom">
    <ion-fab-button size="small"
                    title="ภาษาไทย"
                    (click)="switchLang('th')">
      🇹🇭
    </ion-fab-button>

    <ion-fab-button size="small"
                    title="English"
                    (click)="switchLang('en')">
      🇺🇸
    </ion-fab-button>
  </ion-fab-list>
</ion-fab>




